import React from 'react';
import Base from './Base';
import SelectAsync from 'react-select/async';

export default class ImportExcel extends Base {
    constructor(props) {
        super(props);
        this.state = {
            type: props.Type,
            companyId: props.CompanyId,
            caller: props.Caller,
            file: '',
            loading: true,
            fields: [],
            version: this.uuidv4(),

            templateId: null,
            title: ''
        }
        this.state.fields = this.getFields();
    }
    componentDidMount() {
    }
    uploadFile(event) {
        var _this = this;
        let file = event.target.files[0];
        if (file) {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                _this.state.file = reader.result;
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        }
    }
    getFields() {
        var t = [];
        if (this.state.type === 2) {
            t = [
                { type: 'text', enable: true, name: 'Name', caption: 'نام', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'BranchCode', caption: 'کد شعبه', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'NationalId', caption: 'کد/شناسه ملی', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'EconomicCode', caption: 'کد اقتصادی', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'Type', caption: 'نوع شخص', index: '', defaultValue: '1' },
                { type: 'text', enable: true, name: 'ZipCode', caption: 'کدپستی', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'PasportNo', caption: 'شماره گذرنامه', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'Mobile', caption: 'موبایل', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'Phone', caption: 'شماره تماس', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'Email', caption: 'آدرس ایمیل', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'Address', caption: 'آدرس', index: '', defaultValue: '' },
            ];
        }
        if (this.state.type === 3) {
            t = [
                { type: 'text', enable: true, name: 'Name', caption: 'نام', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'TaxNumber', caption: 'شماره مالیاتی', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'TaxRate', caption: 'نرخ مالیات', index: '', defaultValue: '10' },
                { type: 'text', enable: true, name: 'Price', caption: 'قیمت واحد', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'UnitCode', caption: 'کدواحد سنجش', index: '', defaultValue: '' },
            ];
        }
        if (this.state.type === 5 || this.state.type === 6 || this.state.type === 7 || this.state.type === 8 ||
            this.state.type === 9 || this.state.type === 10 || this.state.type === 11 || this.state.type === 12) {

            var inp = '1';
            if (this.state.type == 5) inp = '1';
            if (this.state.type == 6) inp = '2';
            if (this.state.type == 7) inp = '3';
            if (this.state.type == 8) inp = '4';
            if (this.state.type == 9) inp = '5';
            if (this.state.type == 10) inp = '6';
            if (this.state.type == 11) inp = '7';
            if (this.state.type == 12) inp = '8';

            t = [
                { type: 'text', enable: true, name: 'inno', caption: 'سریال داخلی صورتحساب', index: '', defaultValue: '' },
                {
                    type: 'select', enable: true, name: 'ins', caption: 'موضوع', index: '', defaultValue: '1', items: [
                        { value: '1', label: '1 - اصلی' },
                        { value: '2', label: '2 - اصلاحی' },
                        { value: '3', label: '3 - ابطالی' },
                        { value: '4', label: '4 - برگشت از فروش' },
                    ]
                },
                {
                    type: 'select', enable: true, name: 'inty', caption: 'نوع', index: '', defaultValue: '1', items: [
                        { value: '1', label: '1 - نوع اول' },
                        { value: '2', label: '2 - توع دوم' },
                        { value: '3', label: '3 - نوع سوم' },
                    ]
                },
                {
                    type: 'text', enable: false, name: 'inp', caption: 'الگوی', index: '', defaultValue: inp
                },
                { type: 'text', enable: true, name: 'custname', caption: 'نام مشتری', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'nationalid', caption: 'کد/شناسه ملی', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'ecocode', caption: 'کد اقتصادی', index: '', defaultValue: '' },
                {
                    type: 'select', enable: true, name: 'tob', caption: 'نوع مشتری', index: '', defaultValue: '1', items: [
                        { value: '1', label: '1 - حقیقی' },
                        { value: '2', label: '2 - حقوقی' },
                        { value: '3', label: '3 - مشارکت مدنی' },
                        { value: '4', label: '4 - اتباع غیر ایرانی' },
                    ]
                },
                { type: 'text', enable: true, name: 'indatim', caption: 'تاریخ صورتحساب', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'irtaxid', caption: 'شماره مالیاتی مرجع', index: '', defaultValue: '' },
                {
                    type: 'select', enable: inp === '6', name: 'ft', caption: 'نوع پرواز', index: '', defaultValue: '1', items: [
                        { value: '1', label: '1 - داخلی' },
                        { value: '2', label: '2 - خارجی' },
                    ]
                },
                { type: 'text', enable: inp === '7', name: 'scln', caption: 'شماره پروانه گمرکی', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '7', name: 'scc', caption: 'کد گمرک محل اظهار فروشنده', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '7', name: 'cdcn', caption: 'شماره کوتاژ', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '7', name: 'cdcd', caption: 'تاریخ کوتاژ', index: '', defaultValue: '' },

                { type: 'text', enable: true, name: 'crn', caption: 'شناسه یکتای ثبت قرارداد', index: '', defaultValue: '' },

                { type: 'text', enable: inp === '5', name: 'billid', caption: 'شماره اشتراک/شناسه قبض بهره بردار', index: '', defaultValue: '' },

                {
                    type: 'select', enable: true, name: 'setm', caption: 'روش تسویه', index: '', defaultValue: '1', items: [
                        { value: '1', label: '1 - نقد' },
                        { value: '2', label: '2 - نسیه' },
                        { value: '3', label: '3 - نقد/نسیه' },
                    ]
                },
                { type: 'text', enable: true, name: 'tax17', caption: 'مالیات موضوع ماده 17', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'factorno', caption: 'شماره فاکتور', index: '', defaultValue: '' },

                { type: 'text', enable: inp === '8', name: 'lno', caption: 'شماره بارنامه', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'lrno', caption: 'شماره بارنامه مرجع', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'ocu', caption: 'کشور مبدا', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'oci', caption: 'شهر مبدا', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'dco', caption: 'کشور مقصد', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'dci', caption: 'شهر مقصد', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'tid', caption: 'شناسه ملی/ شماره ملی/ شناسه مشارکت مدنی/ کد فراگیر اتباع غیر ایرانی فرستنده', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'rid', caption: 'شناسه ملی/ شماره ملی/ شناسه مشارکت مدنی/ کد فراگیر اتباع غیر ایرانی گیرنده', index: '', defaultValue: '' },
                {
                    type: 'select', enable: inp === '8', name: 'lt', caption: 'نوع بارنامه', index: '', defaultValue: '1', items: [
                        { value: '1', label: '1 - جاده ای' },
                        { value: '2', label: '2 - ریلی' },
                        { value: '3', label: '3 - هوایی' },
                        { value: '4', label: '4 - دریایی' },
                    ]
                },
                { type: 'text', enable: inp === '8', name: 'cno', caption: 'شماره ناوگان', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'did', caption: 'کد ملی/ کد فراگیر اتباع غیر ایرانی راننده) در حمل و نقل جاده ای(', index: '', defaultValue: '' },

                { type: 'text', enable: true, name: 'stufftaxnumber', caption: 'شماره مالیاتی کالا', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'stufftaxname', caption: 'شرح کالا و خدمات', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'unittaxnumber', caption: 'شماره مالیاتی واحد کالا', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'am', caption: 'تعداد', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'nw', caption: 'وزن خالص', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'fee', caption: 'قیمت', index: '', defaultValue: '0' },

                { type: 'text', enable: (inp === '2' || inp === '7'), name: 'cfee', caption: 'میزان ارز', index: '', defaultValue: '0' },
                { type: 'text', enable: (inp === '2' || inp === '7'), name: 'cut', caption: 'نوع ارز', index: '', defaultValue: 'IRR' },
                { type: 'text', enable: (inp === '2' || inp === '7'), name: 'exr', caption: 'نرخ برابری ارز با ریال', index: '', defaultValue: '0' },
                { type: 'text', enable: (inp === '2' || inp === '7'), name: 'ssrv', caption: 'ارزش ریالی کالا', index: '', defaultValue: '0' },
                { type: 'text', enable: (inp === '2' || inp === '7'), name: 'sscv', caption: 'ارزش ارزی کالا', index: '', defaultValue: '0' },

                //{ type: 'text', enable: true, name: 'prdis', caption: 'مبلغ قبل از تخفیف', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'dis', caption: 'مبلغ تخفیف', index: '', defaultValue: '0' },
                //{ type: 'text', enable: true, name: 'adis', caption: 'مبلغ بعد از تخفیف', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'vra', caption: 'نرخ مالیات', index: '', defaultValue: '10' },
                { type: 'text', enable: true, name: 'vam', caption: 'مبلغ مالیات بر ارزش افزوده', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'odt', caption: 'موضوع سایر مالیات و عوارض', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'odr', caption: 'نرخ سایر مالیات و عوارض', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'odam', caption: 'مبلغ سایر مالیات و عوارض', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'olt', caption: 'موضوع سایر وجود قانونی', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'olr', caption: 'نرخ سایر وجود قانونی', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'olam', caption: 'مبلغ سایر وجود قانونی', index: '', defaultValue: '0' },

                { type: 'text', enable: inp === '3', name: 'consfee', caption: 'اجرت ساخت', index: '', defaultValue: '0' },
                { type: 'text', enable: inp === '3', name: 'spro', caption: 'سود فروش', index: '', defaultValue: '0' },
                { type: 'text', enable: inp === '3', name: 'bros', caption: 'حق العمل', index: '', defaultValue: '0' },
                { type: 'text', enable: inp === '3', name: 'tcpbs', caption: 'جمع کل اجرت ، حق العمل  و سود', index: '', defaultValue: '0' },

                { type: 'text', enable: true, name: 'cop', caption: 'سهم نقدی از پرداخت', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'vop', caption: 'سهم مالیات بر ارزش افزوده از پرداخت', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'bsrn', caption: 'شناسه یکتای ثبت حق العمل کاری', index: '', defaultValue: '' },

                { type: 'text', enable: true, name: 'iinn', caption: 'شماره سویچ پرداخت', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'acn', caption: 'شماره پذیرنده فروشگاهی', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'trmn', caption: 'شماره پایانه', index: '', defaultValue: '' },
                {
                    type: 'select', enable: true, name: 'pmt', caption: 'روش پرداخت', index: '', defaultValue: '1', items: [
                        { value: '1', label: '1 - چک' },
                        { value: '2', label: '2 - تهاتر' },
                        { value: '3', label: '3 - وجه نقد' },
                        { value: '4', label: '4 - pos' },
                        { value: '5', label: '5 - درگاه اینترنتی' },
                        { value: '6', label: '6 - کارت به کارت' },
                        { value: '7', label: '7 - انتقال به حساب' },
                        { value: '8', label: '8 - سایر موارد' },
                    ]
                },
                { type: 'text', enable: true, name: 'trn', caption: 'شماره پیگیری', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'pcn', caption: 'شماره کارت پرداخت کننده صورتحساب', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'pid', caption: 'شماره/شناسه ملی/کد فراگیر اتباع غیر ایرانی پرداخت کننده صورتحساب', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'pdt', caption: 'تاریخ و زمان تراکنش', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'pv', caption: 'مبلغ پرداخت', index: '', defaultValue: '0' },

            ];
        }
        return t;
    }
    setField(name, index) {
        this.state.fields.forEach(f => {
            if (f.name === name) f.index = index;
        });
    }
    setDefaultValue(name, index) {
        this.state.fields.forEach(f => {
            if (f.name === name) f.defaultValue = index;
        });
    }
    saveTemplate(e) {
        e.preventDefault();
        var body = {
            id: this.state.templateId,
            title: this.state.title,
            type: this.state.type.toString(),
            configs: JSON.stringify({
                fields: this.state.fields
            })
        }
        this.httpPost("/api/v1/excelimporttemplate/save", body)
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("الگو با موفقیت ذخیره شد");
                    this.state.templateId = data.id;
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.")
            });
    }
    save(e) {
        e.preventDefault();
        if (this.isBlank(this.state.file)) {
            this.showErorrMessage('لطفا فایل اکسل مورد نظر خود را اپلود نمایید');
            return;
        }
        var url = "";
        if (this.state.type === 2) {
            url = "api/v1/person/upload";
        }
        if (this.state.type === 3) {
            url = "api/v1/stuff/upload";
        }

        if (this.state.type === 5 || this.state.type === 6 || this.state.type === 7 || this.state.type === 8 ||
            this.state.type === 9 || this.state.type === 10 || this.state.type === 11 || this.state.type === 12) {
            url = "api/v1/invoice/upload";
        }
        if (this.state.type === 40) {
            url = "api/v1/invoice/upload_parsian";
        }
        if (this.state.type === 50) {
            url = "api/v1/invoice/upload_irankhodro";
        }
        if (this.state.type === 60) {
            url = "api/v1/invoice/upload_saipa";
        }
        this.httpPost(url, {
            companyId: this.state.companyId,
            file: this.state.file,
            fields: this.state.fields
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ثبت شد شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.")
            });
    }
    setTemplate(e) {
        var configs = JSON.parse(e.configs);
        this.setState({
            version: this.uuidv4(),
            fields: configs.fields,
            templateId: e.value,
            title: e.label
        });
    }
    isFixedTemplate() {
        if (this.state.type !== 40 && this.state.type !== 50 && this.state.type !== 60)
            return true;
        return false;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">ورود اکسل اطلاعات</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <p>از طریق این بخش می تواند اطلاعات خود را به صورت دسته جمعی از طریق فایل اکسل وارد سامانه نمایید.</p>
                                        {this.isFixedTemplate() && <p>برای اینکار بایستی فایل اکسل داده های مورد نظرتان را آپلود نموده و سپس مشخص نمایید که کدام ستون های فایل اکسل در سیستم بارگذاری شوند</p>}
                                        <div style={{ "margin": "40px 0" }} >
                                            <input type="file" onChange={e => this.uploadFile(e)} />
                                        </div>
                                    </div>
                                </div>
                                {this.isFixedTemplate() && <div className="row">
                                    <div className="col-sm-10">
                                        <div className="form-group">
                                            <label>عنوان الگو جهت ذخیره تنظیمات و استفاده مجدد</label>
                                            <input key={this.state.version} onChange={e => this.state.title = e.target.value} defaultValue={this.state.title} autocomplete="off" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <button type="submit" onClick={e => this.saveTemplate(e)} className="btn btn-warning">
                                            ذخیره الگو
                                        </button>
                                    </div>
                                </div>}
                                {this.isFixedTemplate() && <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label className="form-label">فراخوانی الگوی ذخیره شده تنظیمات</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
                                                    defaultValue={null}
                                                    isMulti={false}
                                                    placeholder="انتخاب الگو"
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    noOptionsMessage={({ inputValue }) =>
                                                        inputValue ? "نتیجه‌ای یافت نشد" : null
                                                    }
                                                    defaultOptions={[]}
                                                    loadOptions={(inputValue, callback) => this.loadExcelImportTemplatesOptions(inputValue, callback, this.state.type.toString())}
                                                    onChange={e => this.setTemplate(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                {!this.isEmpty(this.state.fields) && <div className="card-inner p-0" key={this.state.version}>
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">عنوان فیلد اطلاعاتی</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره ستون در فایل اکسل</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">مقدار پیش فرض</span></div>
                                        </div>
                                        {this.state.fields.map((record, index) =>
                                            record.enable && <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.caption}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                        <input type="text" className="form-control" placeholder="برای مثال A" onChange={e => this.setField(record.name, e.target.value)} defaultValue={record.index} />
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                        {record.type === "text" && <input type="text" className="form-control ms-1" placeholder="" onChange={e => this.setDefaultValue(record.name, e.target.value)} defaultValue={record.defaultValue} />}
                                                        {record.type === "select" && <select className="form-control" onChange={e => this.setDefaultValue(record.name, e.target.value)} defaultValue={record.defaultValue}>
                                                            {record.items.map(item => <option value={item.value}>{item.label}</option>)}
                                                        </select>}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                بارگذاری
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        let contents =
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}